import { Grid } from 'theme-ui';
import useMatchMedia from '~/hooks/utils/use-match-media';
import GenericSlider from '~/components/Generic/GenericSlider';
import KitVariantProductCard from '~/components/Collection/Page/KitVariantProductCard';

export default function ProductGalleryList({
  presentationalProductCards,
  fromProductSection,
  validateChildren,
  collection,
}) {
  const isMobile = useMatchMedia('mobile');
  if (!presentationalProductCards || !presentationalProductCards.length) return null;

  const productCards = presentationalProductCards.map((item) => {
    if (!validateChildren(item?.content?.__typename)) return null;
    const cardCollection = collection ?? item?.content?.collection?.[0];
    return (
      <KitVariantProductCard
        key={item.id}
        wrapperSx={{ height: ['100%', 'auto'] }}
        forwardSx={{ '--card-scaling': 0, height: '100%' }}
        cdpCopy={item.cdpCopy}
        fromProductSection={fromProductSection}
        item={item.content}
        collectionSlug={cardCollection?.slug}
        cardDirection={item.cardDirection}
        isFeaturedCard={false}
        {...item}
      />
    );
  });

  return (
    <Grid
      data-testid="product-gallery-list"
      sx={{
        position: 'relative',
        pr: [0, '4rem'],
        pl: ['2.4rem', '4rem'],
        gridTemplateColumns: ['1fr', 'repeat(3, 1fr)'],
      }}
    >
      {isMobile ? (
        <GenericSlider
          sliderSettings={{ arrows: false }}
          forwardSx={{
            '.slick-dots': {
              position: 'relative',
              bottom: 0,
              pt: '1rem',
              pr: '2.4rem',
            },
            '.slick-track': {
              height: '100%',
              display: 'grid',
              gridAutoFlow: 'column',
            },
            '.slick-slide': {
              pr: '2.4rem',
              ' & > div': { height: '100%' },
            },
          }}
        >
          {productCards}
        </GenericSlider>
      ) : (
        productCards
      )}
    </Grid>
  );
}

ProductGalleryList.defaultProps = {
  validateChildren: () => true,
};
